import {httpGet, httpPost} from './http';
import {getActiveProfile} from '../lib/activeMember';
import {ucFirst, ucFirstArray} from './misc';
import {Tooltip, Tag} from 'antd';
import React from 'react';

const {CheckableTag} = Tag;

const contactMethodUrl = window.env.BACKEND_API_URL + '/contact_methods';
const contactCategoryUrl = window.env.BACKEND_API_URL + '/contact_categories';

//region Email

const getEmails = async (signal) => {
    let emailUrl = `${contactMethodUrl}/?method=email`;

    let profileID = getActiveProfile().id;
    emailUrl = `${emailUrl}&contactable_id=${profileID}&contactable_type=profile`;

    return await httpGet(emailUrl, signal);
};

const addEmail = async ({email, profileID}, signal) => {
    const type = 'profile';
    const method = 'email';

    const body = {
        'contactable_id': profileID || getActiveProfile().id,
        'contactable_type': type,
        'method': method,
        'value': email,
    };

    return httpPost(contactMethodUrl, body, signal);
};

const sendMassEmail = async (email, signal) => {
    let sendMassEmailUrl = `${contactMethodUrl}/send_mass_email`;

    return await httpPost(sendMassEmailUrl, email, signal)
};

const getMassEmailCount = async (signal) => {
    let massEmailUrl = `${contactMethodUrl}/get_mass_email_count`;

    return await httpGet(massEmailUrl, signal);
}

const attachEmailForBookingNotification = async (contactMethodID, signal) => {
    const bookingCategory = 1;
    const contactMethodsUrl = contactMethodUrl + "/subscribe";

    let body = {
        'contact_method_id': contactMethodID,
        'contact_category_id': bookingCategory,
    };

    return httpPost(contactMethodsUrl, body, signal);
};

//endregion

//region Contact Category

const getContactCategories = async (type, signal) => {
    let url = contactCategoryUrl;

    if (type) {
        url = `${contactCategoryUrl}/?type=${type}`;
    }
    return await httpGet(url, signal);
};

const subscribeToContactCategory = async (contactMethodID, contactCategoryID, signal) => {
    const url = `${contactMethodUrl}/subscribe`;

    let body = {
        'contact_method_id': contactMethodID,
        'contact_category_id': contactCategoryID,
    };

    return await httpPost(url, body, signal);
};

const unsubscribeToContactCategory = async (contactMethodID, contactCategoryID, signal) => {
    const url = `${contactMethodUrl}/unsubscribe`;

    let body = {
        'contact_method_id': contactMethodID,
        'contact_category_id': contactCategoryID,
    };

    return await httpPost(url, body, signal);
};

//endregion

//region Address Tags

// Note that mandatoryTypes should be an array
const getMandatoryTagTooltipText = (mandatoryTypes, action) => {
    const multipleTypes = mandatoryTypes.length > 1;
    let out = '';

    // construct the string
    if (!multipleTypes) {
        out += 'A ' + mandatoryTypes;
    } else {
        out += ucFirstArray(mandatoryTypes);
    }

    if (!multipleTypes) {
        out += ' address is';
    } else {
        out += ' addresses are';
    }

    out += ' required. To ' + action + ', set ';

    if (!multipleTypes) {
        out += ' another address';
    } else {
        out += ' other addresses';
    }

    out += ' as ' + mandatoryTypes.join(', ') + ' addresses first.';

    return out;
};

const renderCheckableAddressTypeTag = (type, checked, setChecked, mandatoryTypes) => {
    // We only need the tooltip to show if the current checked tag is a mandatory type.
    const tooltipText = mandatoryTypes?.includes(type) ? getMandatoryTagTooltipText([type], 'remove this type') : '';
    return (
        <Tooltip title={tooltipText} placement="bottom">
            <CheckableTag
                style={{
                    color: checked ? 'white' : 'dimgrey',
                    background: checked ? '#1890ff' : 'lightgrey',
                }}
                checked={checked}
                onChange={(checked) => setChecked(prev => ({...prev, [type]: checked}))}
            >
                {ucFirst(type)}
            </CheckableTag>
        </Tooltip>
    )
};

//endregion

export {
    addEmail,
    attachEmailForBookingNotification,
    sendMassEmail,
    getMassEmailCount,
    getContactCategories,
    getEmails,
    subscribeToContactCategory,
    unsubscribeToContactCategory,
    getMandatoryTagTooltipText,
    renderCheckableAddressTypeTag,
}